import { createFileRoute } from '@tanstack/react-router'

import { AnalyticsCompanyOverviewTabPanel } from '@/analytics/components/AnalyticsCompanyOverviewTabPanel/AnalyticsCompanyOverviewTabPanel'
import { TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED } from '@/core/constants/constants'
import { track } from '@/core/utils/tracking/track'

export const Route = createFileRoute('/company/_management/analytics/')({
  component: AnalyticsCompanyOverviewTabPanel,
  onEnter: () => {
    track(TRACK_ANALYTICS_DASHBOARD_PAGE_NAVIGATED, {
      dashboard_page: 'company-overview',
    })
  },
})
